import React from 'react'
import ReactDOM from 'react-dom/client'
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import theme from './theme/theme.ts'
import { Worker } from '@react-pdf-viewer/core'
import App from './App.tsx'
import awsConfig from './aws-exports.ts'
import { Amplify } from 'aws-amplify'
import './index.css'

Amplify.configure(awsConfig)

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<ColorModeScript initialColorMode={theme.config?.initialColorMode} />
		<ChakraProvider theme={theme}>
			<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
				<App />
			</Worker>
		</ChakraProvider>
	</React.StrictMode>,
)
